import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../auth/useAuth'

export default function BottomNav() {
    const { t } = useTranslation()
    const { clientauth } = useAuth()
    const { pathname } = useLocation()
    const rol = String(clientauth?.rol || '').toLowerCase()

    const basePath = `/${t('url.' + rol)}`

    const isActive = (path) => {
        const current = pathname.replace(/^\/+/, '')
        return current === path || current.startsWith(path + '/')
    }

    const items = [
        {
            to: `${basePath}/${t('url.dashboard')}`,
            icon: 'fas fa-home',
            label: t('menu.index') || 'Inicio'
        },
        {
            to: `${basePath}/${t('url.chatbot')}`,
            icon: 'fas fa-comment-dots',
            label: t('menu.chatbot') || 'Chat IA'
        },
        ...(rol !== 'commercial' ? [{
            to: `${basePath}/${t('url.products')}`,
            icon: 'fas fa-search',
            label: t('menu.products') || 'Productos'
        }] : [])
    ]

    return (
        <nav className="bottom-nav d-lg-none">
            {items.map((item, i) => (
                <Link
                    key={i}
                    to={item.to}
                    className={`bottom-nav-item ${isActive(item.to) ? 'active' : ''}`}
                >
                    <i className={item.icon}></i>
                    <span>{item.label}</span>
                </Link>
            ))}
        </nav>
    )
}
